<template>
    <div class="wrapper">
        <v-layout justify-center>
            <v-container
                    grid-list-md text-xs-center
            >
                <v-layout row wrap pa-2>
                    <v-flex xs12>
                        <v-card
                                class="pa-4"
                                flat
                        >
                            <v-toolbar
                                    dense
                            >
                                <v-text-field
                                        hide-details
                                        single-line
                                        :label="$t('Customer Name')"
                                        v-model="search.name"
                                ></v-text-field>
                            </v-toolbar>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 class="text-right">
                        <v-btn
                                color=""
                                @click="set_edit_customer({})"
                        >
                            <v-icon>
                                mdi-plus
                            </v-icon>
                        </v-btn>
                    </v-flex>
                  <v-flex v-show="search_customers.length" xs12>
                    <h3>
                      {{ $t('Search Customers') }}
                    </h3>
                  </v-flex>
                  <v-flex
                      v-for="(customer, index) in search_customers"
                      :key="customer.id"
                      xs12 md4 sm4 lg2 pa-2
                  >
                    <v-card
                        @click="load_orders(customer)"
                    >
                      <v-card-text class="px-0 text-center">
                        {{ $t(customer.name) }}
                      </v-card-text>
                    </v-card>
                  </v-flex>
                    <v-flex xs12 v-show="live_customers.length">
                        <h3>
                            {{ $t('Live Order Customers') }}
                        </h3>
                    </v-flex>
                    <v-flex
                            v-for="(customer, index) in live_customers"
                            :key="customer.id"
                            xs12 md4 sm4 lg2 pa-2
                    >
                        <v-card
                                @click="load_orders(customer)"
                        >
                            <v-card-text class="px-0 text-center">
                                {{ $t(customer.name) }}
                            </v-card-text>
                        </v-card>
                    </v-flex>


                    <v-flex xs12>
                        <h3>
                            {{ $t('All Customers') }}
                        </h3>
                    </v-flex>

                    <div v-infinite-scroll="load_customers" infinite-scroll-disabled="is_loading" infinite-scroll-distance="10">
                         <v-container>
                             <v-row>
                                 <v-col cols="12" sm="4" md="4" v-for="(customer, index) in filteredList ">
                                     <v-card
                                             v-bind:class="{'yellow darken-2 white--text':customer.has_tabs && !customer.credit.credit, '':!customer.has_tabs, 'green accent-2':customer.credit.credit > 0}"
                                             @click="load_orders(customer)"
                                     >
                                         <v-card-text class="px-0 text-center">
                                             {{ customer.name }}
                                         </v-card-text>
                                     </v-card>
                                 </v-col>

                                 <v-col cols="12" sm="4" md="4">
                                     <v-card @click="load_staff()"
                                             color="blue-grey darken-4"

                                             class="px-4">
                                         <v-card-text class="white--text text-center">
                                             {{ $t('End') }}
                                         </v-card-text>
                                     </v-card>
                                 </v-col>
                             </v-row>
                         </v-container>
                    </div>

                </v-layout>
            </v-container>
        </v-layout>

        <v-dialog v-model="edit_customer_dialog" width="600">
            <v-card class="px-5">
                <v-flex xs12>
                    <v-text-field
                            v-model="editCustomer.name"
                            :counter="200"
                            label="Name"
                            required
                            :error-messages="checkName"
                            @input="$v.editCustomer.name.$touch()"
                            @blur="$v.editCustomer.name.$touch()"
                    ></v-text-field>
                </v-flex>

                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="green darken-1" text @click="edit_customer_dialog = false">Cancel</v-btn>
                    <v-btn color="green darken-1" text @click="save_customer(editCustomer)">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
    import {validationMixin} from 'vuelidate'
    import {required, maxLength, minLength, email} from 'vuelidate/lib/validators'

    export default {
        mixins: [validationMixin],

        validations: {
            editCustomer: {
                name: {
                    required,
                    minLength: minLength(2),
                    maxLength: maxLength(200)
                }
            }
        },
        computed: {
            filteredList() {
                return this.customers.filter(customer => {
                    return customer.name.toLowerCase().includes(this.search.name.toLowerCase())
                })
            },
            checkName() {
                const errors = [];
                if (!this.$v.editCustomer.name.$dirty) return errors;
                !this.$v.editCustomer.name.maxLength && errors.push('.name must be at most 2 characters long');
                !this.$v.editCustomer.name.minLength && errors.push('.name must be at least 200 characters long');
                !this.$v.editCustomer.name.required && errors.push('.name is required.');
                return errors;
            },
        },
        components: {},
        watch: {
          'search.name': function(nv) {
            if(!this.is_loading && nv && nv !== '')
              this.getCustomer(nv)
          }
        },
        data() {
            return {
                customers: [],
                form_type: 'new',
                db_link: '',
                edit_fields: [],
                dialog: false,
                show_flash: false,
                flash_message: '',
                flash_type: 'success',
                selected_item: {},
                edit_title: '',
                search: {
                    name: ''
                },
                search_url: '',
                staff_id: 0,
                defaultCustomer: {
                    id: 0,
                    name: ''
                },
                editCustomer: {
                    id: 0,
                    name: ''
                },
                edit_customer_dialog: false,
                live_customers: [],
                load_url: null,
                is_loading:false,
                init_load: true,
                count:0,
                is_searching: false,
                default_customers:[],
                search_customers:[]
            }
        },
        created() {

            this.staff_id = parseInt(this.$route.params.staff_id);

            if(localStorage.getItem('customers'))
            {
                console.log("Customers Saved");
                this.load_cache_customers();
            } else {
                console.log('CUSTOMERS NOT SAVED');
                this.load_customers();
            }

            let language_id = localStorage.getItem('language_id');
            let language = 'en';
            if(language_id)
            {
                language = language_id;
            } else {
                let chinese_staff_ids = [3, 7, 8];
                if (chinese_staff_ids.includes(this.staff_id)) {
                    language = 'zh';
                }
            }
            this.$i18n.locale = language;
        },
        methods: {
          getCustomer(name) {
            let sync_url = this.$http.defaults.baseURL+'/staff/customers/?limit=20&name='+name;
            this.is_loading = true;
            this.$http.get(sync_url + this.search_url)
                .then((response) => {
                  console.log(response);
                  this.search_customers = response.data.results;
                  this.$forceUpdate();

                })
                .catch((error) => {
                  console.log('search error');
                  console.log(error);
                }).finally(this.is_loading = false);
          },
            load_cache_customers()
            {
                this.customers = JSON.parse(localStorage.getItem('customers'));
                this.load_live_order_customers();
            },
            load_staff() {
                this.$router
                    .push({path: '/c-panel/staff/'})
            },
            save_customer(customer) {

                this.$v.editCustomer.$touch();
                if (this.$v.editCustomer.$invalid) {
                    this.notification = true;
                    this.notification_type = 'red darken-2';
                    this.notification_message = 'Please fill the form out correctly';
                    return false;
                }
                this.$http.post(
                    this.$http.defaults.baseURL + '/staff/customers/', customer).then((response) => {
                    this.notification = true;
                    this.notification_message = 'Successfully added a new customer.';
                    this.customers.push(response.data);
                    localStorage.removeItem('customers');

                    localStorage.setItem('customers', JSON.stringify(this.customers));
                    // this.load_customers();
                    this.edit_customer_dialog = false;

                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });
            },
            close_sidebar() {

            },
            set_edit_customer(customer) {
                if (typeof customer.id === 'undefined') {
                    this.editCustomer = this.defaultCustomer;
                } else {
                    this.editCustomer = customer;
                }
                this.edit_customer_dialog = true;
            },
            load_orders(c) {
                this.$router
                    .push({path: '/c-panel/products/' + this.staff_id + '/' + c.id})
            },
            load_customers() {
                let sync_url = this.$http.defaults.baseURL+'/staff/customers/?sm=0&limit=1000';
                if (this.load_url && this.is_searching === false)
                    sync_url = this.load_url;
                if(!this.load_url && this.customers.length && this.is_searching === false)
                    return false;
                console.log(this.is_loading);
                this.is_loading = true;
                this.$http.get(sync_url + this.search_url)
                    .then((response) => {
                        let self = this;
                        if(this.is_searching === false)
                        {
                            response.data.results.forEach(function(c){
                                self.customers.push(c)
                            });
                            localStorage.setItem('customers', JSON.stringify(this.customers));
                            console.log("CUSTOMERS STORED");
                        } else {
                            this.customers = response.data.results;
                        }

                        this.is_searching = false;
                        this.load_url = response.data.next;
                        if(this.init_load === true)
                        {
                            this.load_live_order_customers();
                        }
                        this.is_loading = false;
                        this.init_load = false;
                        this.$forceUpdate();

                        console.log('loading');
                    })
                    .catch((error) => {
                        this.is_searching = false;
                        this.is_loading = false;
                        this.init_load = false;
                        console.log("page error");
                        console.log(error);
                    });
                console.log(this.is_loading);

            },
            load_live_order_customers() {
                this.live_customers = [];
                // let self = this;
                // this.customers.forEach(function(c){
                //     if(c.orders.length || c.free_drinks.length)
                //     {
                //         self.live_customers.push(c);
                //     }
                // });
                console.log('Loading Live Customers');
                this.$http.get(
                    this.$http.defaults.baseURL + '/staff/live-order-customers/').then((response) => {
                    this.live_customers = response.data;
                })
                    .catch((error) => {
                        this.notification = true;
                        this.notification_message = 'Error: Please contact administrator';
                        console.log("Error");
                        console.log(error);
                    });
            },
            filter_results(search) {
                let search_url = '';
                this.is_searching = true;
                for (let prop in search) {
                    // skip loop if the property is from prototype
                    if (!search.hasOwnProperty(prop)) continue;

                    // your code
                    search_url += '&' + prop + '=' + search[prop];
                }
                if(search_url === '')
                {
                    console.log("RESET CACHE");
                    localStorage.removeItem('customers');
                }
                this.search_url = search_url;
                this.load_customers();
            }
        }
    }
</script>
